import React, { Suspense, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import Layout from 'core/layouts';
import NonAuthLayout from '../../layouts/NonLayout';
import AuthProtected from './AuthProtected';
import ErrorBoundary from '../../components/common/ErrorBoundary';

// Custom hook to cleanup body scroll on route changes
const useRouteChangeCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    // Clean up body scroll classes/styles when route changes
    // This prevents stuck scroll from modals, sidebars, etc.
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
  }, [location.pathname]);
};

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-500"></div>
  </div>
);

const RouteIndex = () => {
  // Cleanup body scroll on route changes
  useRouteChangeCleanup();

  return (
    <React.Fragment>
      <Routes>
        {/* Default route - redirect to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Analytics base route - redirect to first sub-route */}
        <Route path="/analytics" element={<Navigate to="/analytics/influencer-reward-program" replace />} />

        {authProtectedRoutes.map((route, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <ErrorBoundary>
                    <Suspense fallback={<PageLoader />}>
                      <route.component />
                    </Suspense>
                  </ErrorBoundary>
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <ErrorBoundary>
                  <Suspense fallback={<PageLoader />}>
                    <route.component />
                  </Suspense>
                </ErrorBoundary>
              </NonAuthLayout>
            } />
        ))}

        {/* Catch-all route - redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
